import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { DocumentoService } from 'src/app/services/documento.service';
import { EquivalenciaProductoService } from 'src/app/services/equivalencia-producto.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import IEquivalenciaProducto, { IEquivalenciaProductoExtended } from 'src/app/shared/object/equivalencia-producto.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';


@Component({
  selector: 'app-modal-add-edit-equivalencia',
  templateUrl: './modal-add-edit-equivalencia.component.html',
  styleUrls: ['./modal-add-edit-equivalencia.component.scss'],
  providers: [SecurityService],

})
export class ModalAddEditEquivalenciaComponent implements OnInit {

  @Input() optionsProveedor: Array<any> = [];

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  // Modales
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent
  @ViewChild('equivalenciasModal', { static: true }) modalProductoEquivalencias: ModalDirective;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent
  @ViewChild('modalConfirmacionProductoInactivo', { static: true }) modalConfirmacionProductoInactivo: ModalDirective;
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup;
  initialValues: any

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number
  productoSeleccionado: any = null
  equivalencia_producto: IEquivalenciaProductoExtended
  // optionsFormato: any = []
  optionsFormato: Array<any> = [];
  proveedorSeleccionado: any = null
  headerData: any = {}

  // Data & Tmp
  mode: 'ADD' | 'EDIT'

  // Utils
  private log: any
  productSelect: any;
  producto_codigo: number = 0;
  formato_codigo_nombre: string;
  formato_codigo: string;
  ClienteSeleccion: any;

  // Variables para el modal de confirmación de producto inactivo
  productoInactivoTemporal: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private formatoProductoService: FormatoProductosService,
    private rutService: RutService,
    private equivalenciaProductoService: EquivalenciaProductoService,
    private documentoService: DocumentoService
  ) {
    this.log = this.clog.log('MAESTRO-EQUIVALENCIAS-ADD-EDIT')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createFormInitialValues()
    this.createForms()
    this.formChangesSubscriptions()
  }

  createFormInitialValues() {
    this.initialValues = {
      cliente_proveedor_rut: null,
      producto_proveedor: null,
      detalle_producto: null,
      formato_codigo: null,
      factor_equivalencia: null,
      producto_sku: null,
      formato_codigo_top: null,
      activado: true,
      observacion: null,
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      cliente_proveedor_rut: [null, [Validators.required]],
      producto_proveedor: [null, [Validators.required]],
      detalle_producto: [null, [Validators.required]],
      formato_codigo: [null, [Validators.required]],
      factor_equivalencia: [null, [Validators.required, Validators.min(1)]],
      producto_sku: [null, [Validators.required]],
      formato_codigo_top: [null, [Validators.required]],
      activado: [true, [Validators.required]],
      observacion: [null, [Validators.maxLength(200)]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("cliente_proveedor_rut").valueChanges
      .pipe(filter(Boolean), debounceTime(2500))
      .subscribe((cliente_proveedor_rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(cliente_proveedor_rut)
      })

    this.formHeader.get("producto_sku").valueChanges
      .pipe(
        filter((value: string) => value && value.trim().length > 0),
        debounceTime(500)
      )
      .subscribe((codigo: string) => {
        this.log("producto_sku change", codigo)
        if (codigo && codigo.trim().length > 0) {
          // Verificar si ya tenemos este producto seleccionado para evitar búsquedas innecesarias
          if (this.productoSeleccionado && this.productoSeleccionado.sku === codigo.trim()) {
            this.log("Producto ya seleccionado, no es necesario buscar nuevamente");
            return;
          }
          this.modalSeleccionarProducto.searchBySKU(codigo.trim())
        }
      })

    this.formHeader.get('formato_codigo_top').valueChanges
      .pipe(filter(Boolean), debounceTime(100))
      .subscribe((x: string) => {
        const formatoSeleccionado = this.optionsFormato.find(a => a.value == x);
        if (formatoSeleccionado) {
          this.formato_codigo_nombre = formatoSeleccionado.formato_nombre;
          this.formato_codigo = formatoSeleccionado.formato_codigo;
        }
      })
  }

  show() {
    this.mode = 'ADD'
    this.equivalencia_producto = null
    this.setInitialValues()
    this.setCreateValidators()
    this.modalProductoEquivalencias.show()
  }

  loadAndshow(product: any) {
    this.mode = 'ADD';
    this.log('setting', product);
    this.productSelect = product;
    this.formHeader.get('cliente_proveedor_rut').setValue(this.rutService.AgregarDV(product.rut_emisor));

    if (product.sku) {
      this.formHeader.get('producto_proveedor').setValue(product.sku);
      this.formHeader.controls['producto_proveedor'].disable();
    } else {
      this.formHeader.controls['producto_proveedor'].enable();
    }

    this.formHeader.get('detalle_producto').setValue(product.descripcion_producto);
    this.formHeader.get('formato_codigo').setValue(product.formato_codigo);

    this.modalProductoEquivalencias.show();

  }

  private setCreateValidators() {
    this.formHeader.get('cliente_proveedor_rut').setValidators([Validators.required])
    this.formHeader.get('producto_proveedor').setValidators([Validators.required])
    this.formHeader.get('detalle_producto').setValidators([Validators.required])
    this.formHeader.get('formato_codigo').setValidators([Validators.required])
    this.formHeader.get('factor_equivalencia').setValidators([Validators.required])
    this.formHeader.get('producto_sku').setValidators([Validators.required])
    this.formHeader.get('formato_codigo_top').setValidators([Validators.required])
    this.formHeader.get('activado').setValidators([Validators.required])
    this.formHeader.get('observacion',).setValidators([Validators.maxLength(200)])
  }

  private setInitialValues(values = this.initialValues) {
    this.formHeader.clearValidators()
    this.formValidatorsService.setInitialState(this.formHeader, values)

    // Solo limpiar si no hay un producto ya establecido desde loadAndshow()
    if (!this.productSelect) {
      this.modalSeleccionarProducto.clearLast()
      this.modalSeleccionarProveedor.clearLast()
      this.optionsFormato = []
      this.productoSeleccionado = null
      this.proveedorSeleccionado = null
      this.productoInactivoTemporal = null // Limpiar también el producto inactivo temporal
    }
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.log('onProductoSeleccionado', _productoSeleccionado)

    // Verificar si el producto está inactivo
    if (_productoSeleccionado && _productoSeleccionado.activo === false) {
      this.log('Producto seleccionado está inactivo:', _productoSeleccionado)
      this.mostrarModalProductoInactivo(_productoSeleccionado)
      return
    }

    this.productoSeleccionado = _productoSeleccionado

    // Asegurar que el producto_codigo se establezca correctamente
    if (_productoSeleccionado && _productoSeleccionado.codigo) {
      this.producto_codigo = _productoSeleccionado.codigo
      this.log('producto_codigo establecido:', this.producto_codigo)
    }

    this.formHeader.get('producto_sku').setValue(_productoSeleccionado.sku)

    if (this.productoSeleccionado && this.productoSeleccionado.codigo) {
      this.formatoProductoService.GetFormatosByCodigo(
        this.rutEmpresa,
        this.productoSeleccionado.codigo,
        ({ mensajes, respuesta }) => {
          if (respuesta && respuesta.registros) {
            this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
            if (this.equivalencia_producto === null) {
              this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('formato_codigo_top'), this.optionsFormato)
            } else {
              if (!this.equivalencia_producto) {
                this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('formato_codigo_top'), this.optionsFormato)
              } else {
                this.formHeader.get("formato_codigo_top").setValue(this.equivalencia_producto.formato_codigo_top)
              }
            }
          }
        }
      )
    }
  }

  onProductoNoEncontrado(data?: any) {
    // Verificar si es un producto inactivo
    if (data && data.esInactivo && data.producto) {
      this.mostrarModalProductoInactivo(data.producto);
    } else {
      this.resetProductoDetails();
    }
  }

  private mostrarModalProductoInactivo(producto: any) {
    // Mostrar toast informativo
    this.toastService.warning(
      `El producto "${producto.sku} - ${producto.descripcion}" está desactivado`,
      'Producto Desactivado',
      {
        timeOut: 5000,
        closeButton: true,
        progressBar: true,
        positionClass: 'toast-top-right'
      }
    );

    // Guardar el producto temporalmente y mostrar el modal
    this.productoInactivoTemporal = producto;
    this.modalConfirmacionProductoInactivo.show();
  }

  confirmarUsoProductoInactivo() {
    if (this.productoInactivoTemporal) {
      this.aceptarProductoInactivo(this.productoInactivoTemporal);
    }
    this.cerrarModalProductoInactivo();
  }

  rechazarUsoProductoInactivo() {
    this.resetProductoDetails();
    this.cerrarModalProductoInactivo();
    // Forzar la limpieza completa del estado del modal de productos
    this.modalSeleccionarProducto.clearLast();
  }

  private cerrarModalProductoInactivo() {
    this.productoInactivoTemporal = null;
    this.modalConfirmacionProductoInactivo.hide();
  }

  private aceptarProductoInactivo(producto: any) {
    // Usuario acepta usar el producto inactivo
    this.log('Usuario acepta producto inactivo:', producto);
    this.productoSeleccionado = producto;

    // Establecer los valores en el formulario
    this.formHeader.get('producto_sku').setValue(producto.sku);

    // Asegurar que el producto_codigo se establezca correctamente
    if (producto.codigo) {
      this.producto_codigo = producto.codigo;
      this.log('producto_codigo establecido para producto inactivo:', this.producto_codigo);
    }

    // Obtener formatos del producto inactivo
    if (this.productoSeleccionado && this.productoSeleccionado.codigo) {
      this.formatoProductoService.GetFormatosByCodigo(
        this.rutEmpresa,
        this.productoSeleccionado.codigo,
        ({ mensajes, respuesta }) => {
          if (respuesta && respuesta.registros) {
            this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }));
            this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('formato_codigo_top'), this.optionsFormato);
          }
        }
      );
    }

    // Mostrar mensaje de confirmación
    this.toastService.info(`Producto inactivo "${producto.sku}" seleccionado correctamente`, 'Producto Seleccionado');
  }

  resetProductoDetails() {
    this.formHeader.get("producto_sku").reset()
    this.formHeader.get("producto_sku").setValue(null)
    this.formHeader.get("producto_sku").markAsUntouched()

    this.modalSeleccionarProducto.clearLast()

    this.optionsFormato = [] // Limpiar opciones de formato
    this.productoSeleccionado = null
    this.producto_codigo = 0
    this.productoInactivoTemporal = null // Limpiar producto inactivo temporal
    this.log('resetProductoDetails - producto_codigo y estado completamente reseteado')
  }

  createPayload() {
    const { cliente_proveedor_rut, detalle_producto, formato_codigo, activado, observacion, factor_equivalencia, formato_codigo_top } = this.formHeader.value

    // Usar el producto_codigo establecido en onProductoSeleccionado o el del productoSeleccionado
    const producto_codigo = this.producto_codigo || (this.productoSeleccionado && this.productoSeleccionado.codigo) || 0

    this.log('createPayload - producto_codigo:', producto_codigo)
    this.log('createPayload - this.producto_codigo:', this.producto_codigo)
    this.log('createPayload - this.productoSeleccionado:', this.productoSeleccionado)

    const inputParams: { entidad: IEquivalenciaProducto } = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        cliente_proveedor_rut: this.rutService.QuitarDV(cliente_proveedor_rut),
        producto_proveedor: this.formHeader.get('producto_proveedor').value,
        detalle_producto,
        formato_codigo,
        factor_equivalencia,
        producto_codigo: producto_codigo,
        formato_codigo_top,
        observacion: observacion ? observacion.trim() : '',
        activado
      }
    }
    return inputParams
  }

  public create() {

    if (this.formHeader.get('observacion').value)
      this.formHeader.get('observacion').setValue(this.formHeader.get('observacion').value.trim())

    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const inputParams = this.createPayload()
    this.log('inputParams', JSON.stringify(inputParams))

    //agregar equivalencia si no existe
    // this.loading = true
    this.equivalenciaProductoService.create(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { id } = respuesta
      this.producto_codigo = id;

      // Solo continuar con la actualización del documento si la equivalencia se creó exitosamente
      this.actualizarDocumento();
    })
  }

  private actualizarDocumento() {
    //Update lista de Doc
    const ParamsDoc = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        rut_emisor: this.productSelect.rut_emisor,
        folio: this.productSelect.folio,
        tipo_dte_codigo: this.productSelect.tipo_dte_codigo,
        nro_linea: this.productSelect.nro_linea,
        sku: this.productSelect.sku,
        formato_codigo: this.productSelect.formato_codigo,
        descripcion_producto: this.productSelect.descripcion_producto,
        cantidad: this.productSelect.cantidad,
        precio_neto: this.productSelect.precio_neto,
        precio_unitario: this.productSelect.precio_unitario,
        monto_total_neto: this.productSelect.monto_total_neto,
        monto_total: this.productSelect.monto_total,
        es_producto_libre: this.productSelect.es_producto_libre,
        gasto_codigo: this.productSelect.gasto_codigo,
        motivo_devolucion_especifico_codigo: this.productSelect.motivo_devolucion_especifico,
        es_correcion_monto: this.productSelect.es_correcion_monto,
        equivalencia_producto_id: this.productSelect.equivalencia_producto_id,
        producto_codigo: this.productSelect.producto_codigo,
        sku_erp: this.formHeader.get('producto_sku').value,
        descripcion_erp: this.productoSeleccionado.descripcion,
        formato_erp: this.formato_codigo, //value
        formato_nombre: this.formato_codigo_nombre, //label
        precio_erp: this.productSelect.precio_erp,
        total_erp: this.productSelect.total_erp,
        producto_valido: this.productSelect.producto_valido,
        atributos: this.cleanDetalledocumento(this.productSelect.atributos)
      }
    }

    //actualizar equivalencia si existe y agregar nuevo si no existe
    this.documentoService.actualizarDetalleDocCompra(ParamsDoc, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      // Solo si todo fue exitoso, actualizar la lista, cerrar modal y limpiar datos
      this.obtenerLista();
      this.modalProductoEquivalencias.hide();
      this.toastService.success('Operación exitosa');
      this.cleanData();
    });
  }

  // quitar variables de additionalInfo
  private cleanDetalledocumento(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map(p => {
      if (cleanCheck)
        delete p.__typename
    })
    return _detalledocumento
  }

  obtenerLista() {
    const inputParams = {
      entidad: {
        cabecera: {
          rut_emisor: this.productSelect.rut_emisor,
          sucursal_codigo: this.sucursalCodigo,
          folio: this.productSelect.folio,
          tipo_dte_codigo: this.productSelect.tipo_dte_codigo,
          rut_receptor: this.rutEmpresa
        }
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoService.obtenerDocumentoCompra(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null && respuesta !== undefined
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.ClienteSeleccion = respuesta

      this.onSuccess.emit(this.ClienteSeleccion)
    })

  }

  update() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const inputParams = this.createPayload()
    inputParams.entidad.id = this.equivalencia_producto.id
    this.log('inputParams', JSON.stringify(inputParams))

    // this.loading = true
    this.equivalenciaProductoService.update(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.messageRendererService.showInfoMessages(mensajes)
      // const {  } = respuesta
      // this.loading = false
      this.onSuccess.emit()
      this.modalProductoEquivalencias.hide()
      this.toastService.success('Operación exitosa')
    })
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show()
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut)
    this.formHeader.get('cliente_proveedor_rut').setValue(this.proveedorSeleccionado.rutFormato)
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado)
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null
    this.clearProveeData()
  }
  clearProveeData() {
    this.clearContent()
    this.onProveedorChange.emit(null)
  }

  clearContent() {
    this.headerData = {}
    this.formValidatorsService.reset(this.formHeader)
  }

  CloseEquivalenciasModal() {
    this.modalProductoEquivalencias.hide();
    this.cleanData();
  }

  cleanData() {
    this.formValidatorsService.reset(this.formHeader);
    this.formHeader.get('activado').setValue(true);
    this.productoSeleccionado = null;
    this.producto_codigo = 0;
    this.productSelect = null; // Limpiar también el productSelect
    this.productoInactivoTemporal = null; // Limpiar producto inactivo temporal
    this.optionsFormato = []; // Limpiar opciones de formato

    // Limpiar completamente el estado del modal de productos
    this.modalSeleccionarProducto.clearLast();
    this.modalSeleccionarProveedor.clearLast();

    this.log('cleanData - estado completamente limpiado')
  }

}
